import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { ToweInUserDataService } from '../data-services/towein-user-data.service';
import { ToweInDealerRequestModel, ToweInUsageRequestModel } from '../business-entities/towed-in-report-model';

@Injectable({
  providedIn: 'root',
})
export class ToweinUseService {
  selectedDealers: any;
  dealerList: any;
  selectedDate: any;

  toweinUserListRequest: ToweInUsageRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    selectedDealers: [],
    selectedDate: '',
    isExport: false,
  };

  toweinDealerListRequest: ToweInDealerRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    dealerId: '',
    selectedDate: '',
    isExport: false,
  };

  dealerId: string = ''

  constructor(private dataProvider: DataService,

    private toweInUserDataService: ToweInUserDataService) { }

  async getToweInUsageList(requestModel: ToweInUsageRequestModel): Promise<GenericResponse<any>> {
    return this.toweInUserDataService.getToweInUsageList(requestModel);
  }

  async getToweInUsageDealerWiseList(requestModel: ToweInDealerRequestModel): Promise<GenericResponse<any>> {
    return this.toweInUserDataService.getToweInUsageDealerWiseList(requestModel);
  }
}